import * as ReactHookForm from 'react-hook-form';

/**
 * @param formOptions {ReactHookForm.UseFormOptions<ReactHookForm.FieldValues, Object>}
 * @returns {ReactHookForm.UseFormMethods<ReactHookForm.FieldValues>}
 */
export function useForm(formOptions) {
  return ReactHookForm.useForm(formOptions);
}
